const initialState = {
    toggleMessage: false,
    message: null,
    messageType: null,
};
  
  export default function MessageReducer(state = initialState, action) {
    switch (action.type) {
      case "TOGGLE_MESSAGE_OPEN": {
        return {
            ...state,
            toggleMessage: true,
            message: action.message,
            type: action.messageType,
        };
      }
  
      case "TOGGLE_MESSAGE_CLOSE": {
        return {
            ...state,
            toggleMessage: false,
            message: null,
            type: null,
        };
      }
  
      default: {
        return state;
      }
    }
  }